/* src/app/modules_v2/income/preinvoice/components/preinvoice-form/preinvoice-form.components.css */
.pf-form {
  padding-bottom: 2rem;
}
.tf-card mat-card-content {
  padding: 1rem 1.25rem !important;
}
.tf-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.tf-section-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1f2937;
  margin: 0;
}
.tf-summary {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 0.75rem 1.25rem;
  background: #fafafa;
}
.tf-summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #374151;
  padding: 3px 0;
}
.tf-summary-divider {
  border-top: 1px solid #e5e7eb;
  margin: 0.4rem 0;
}
.tf-summary-row--total {
  font-weight: 700;
  font-size: 15px;
  color: #111827;
}
.tf-summary-row--total span:last-child {
  font-size: 16px;
}
.pf-totals-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.75rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.pf-totals-bar__items {
  display: flex;
  align-items: center;
  gap: 0.25rem 0.75rem;
  flex-wrap: wrap;
  color: #6b7280;
  font-size: 0.88rem;
}
.pf-totals-bar__item strong {
  color: #374151;
  font-weight: 600;
}
.pf-totals-bar__sep {
  color: #d1d5db;
}
.pf-totals-bar__total {
  font-size: 0.9rem;
  color: #6b7280;
  white-space: nowrap;
}
.pf-totals-bar__total strong {
  font-size: 1.2rem;
  font-weight: 700;
  color: #111827;
  margin-left: 0.25rem;
}
.pf-section-divider {
  border-top: 1px solid #f0f0f0;
  margin: 0 0 0.75rem;
}
.preinvoice-form {
  background: #fff;
  border-radius: 8px;
}
.preinvoice-form .preinvoice-lines {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 1rem;
  background: #fafafa;
}
.preinvoice-form .line-row {
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.preinvoice-form .footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top: 1px solid #eee;
  padding-top: 1rem;
}
.calendar-wrapper {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  margin: 2rem auto;
}
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.calendar-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f1f1f;
  text-transform: capitalize;
}
.header-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn-nav {
  background: #f3f4f6;
  border: none;
  color: #222;
  font-weight: 500;
  border-radius: 6px;
  padding: 6px 10px;
  transition: background 0.2s;
}
.btn-nav:hover {
  background: #e5e7eb;
}
.btn-today {
  background: var(--cf-brand-dark);
  color: white;
  border-radius: 6px;
  border: none;
  padding: 6px 12px;
  font-weight: 500;
  transition: background 0.2s;
}
.btn-today:hover {
  background: #d88714;
}
.view-switch {
  display: flex;
  align-items: center;
  background: #1f2937;
  border-radius: 6px;
  overflow: hidden;
}
.view-switch button {
  background: none;
  border: none;
  color: white;
  font-weight: 500;
  padding: 6px 12px;
  transition: background 0.2s;
}
.view-switch button.active {
  background: var(--cf-brand-dark);
  color: #fff;
}
.view-switch button:hover {
  background: #374151;
}
::ng-deep .cal-event {
  background: var(--cf-brand-dark) !important;
  border: none !important;
  border-radius: 3px;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 2px 4px !important;
}
::ng-deep .cal-day-cell.cal-today {
  background: #fff8e1 !important;
  border: 2px solid var(--cf-brand-dark) !important;
}
::ng-deep .cal-day-number {
  font-weight: 600 !important;
  color: #2e2e2e !important;
}
::ng-deep .cal-header {
  background: #f9fafb !important;
  color: #444;
  font-weight: 600;
  border-radius: 10px 10px 0 0;
}
::ng-deep mwl-calendar-month-view,
::ng-deep mwl-calendar-week-view,
::ng-deep mwl-calendar-day-view {
  border-radius: 10px;
}
::ng-deep .cal-day-cell {
  border-color: #f0f0f0 !important;
}
@media (max-width: 768px) {
  .calendar-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.view-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  background: #fff;
  border-radius: 12px;
  padding: 10px 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.view-title mat-icon {
  color: var(--cf-brand-dark);
}
::ng-deep .cal-event {
  display: flex;
  align-items: center;
  background: #fff5e6 !important;
  border: 1px solid var(--cf-brand-dark) !important;
  border-left: 5px solid var(--cf-brand-dark) !important;
  border-radius: 8px !important;
  padding: 6px 10px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .cal-event:hover {
  background: var(--cf-brand-dark) !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(236, 151, 31, 0.3);
}
::ng-deep .cal-event-title {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
::ng-deep .cal-day-cell.cal-today {
  background: #fffaf3 !important;
  border: 2px solid var(--cf-brand-dark) !important;
  border-radius: 10px;
}
::ng-deep .custom-event {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 1.2;
}
::ng-deep .custom-event .event-title {
  font-weight: 600;
  color: #2d2d2d;
}
::ng-deep .custom-event .event-desc {
  color: #555;
  font-size: 12px;
  opacity: 0.9;
}
::ng-deep .custom-month-event,
::ng-deep .cal-event {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff5e6 !important;
  border: 1px solid var(--cf-brand-dark) !important;
  border-left: 5px solid var(--cf-brand-dark) !important;
  border-radius: 8px !important;
  padding: 4px 8px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
  overflow: hidden;
}
::ng-deep .custom-month-event:hover,
::ng-deep .cal-event:hover {
  background: var(--cf-brand-dark) !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(236, 151, 31, 0.25);
}
::ng-deep .custom-month-event .contact,
::ng-deep .cal-event .contact {
  font-weight: 600;
  font-size: 13px;
  color: #1f1f1f;
  margin-bottom: 2px;
}
::ng-deep .custom-month-event .title,
::ng-deep .cal-event .title {
  font-size: 12px;
  color: #444;
  opacity: 0.9;
}
::ng-deep .cal-week-view .cal-event,
::ng-deep .cal-day-view .cal-event {
  border-radius: 8px !important;
  padding: 6px 8px !important;
  font-size: 12px !important;
  white-space: normal !important;
  line-height: 1.2 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
::ng-deep .cal-day-cell.cal-today {
  background: #fffaf3 !important;
  border: 2px solid var(--cf-brand-dark) !important;
  border-radius: 10px;
}
::ng-deep .custom-event {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff5e6 !important;
  border: 1px solid var(--cf-brand-dark) !important;
  border-left: 5px solid var(--cf-brand-dark) !important;
  border-radius: 8px !important;
  padding: 6px 10px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
}
::ng-deep .custom-event:hover {
  background: var(--cf-brand-dark) !important;
  color: white !important;
  transform: translateY(-2px);
}
::ng-deep .custom-event .contact {
  font-weight: 600;
  font-size: 13px;
  color: #1f1f1f;
  margin-bottom: 2px;
}
::ng-deep .custom-event .title {
  font-size: 12px;
  color: #555;
  opacity: 0.9;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: auto;
  max-width: 500px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  max-height: 90vh;
  z-index: 2001;
  animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.modal h2 {
  margin-top: 0;
  font-size: 20px;
  color: #333;
}
.modal form label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
  color: #444;
}
.modal form input,
.modal form textarea,
.modal form select {
  width: 100%;
  padding: 8px;
  margin-top: 4px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-buttons {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.modal-buttons button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}
.modal-buttons button[type=submit] {
  background-color: #e3fd64;
  color: #1a1d23;
}
.modal-buttons button[type=button] {
  background-color: #ccc;
  color: #333;
}
@media (max-width: 768px) {
  .calendar-main {
    width: 95vw;
    height: 90vh;
    padding: 10px;
  }
  #calendar {
    padding: 0;
    height: 100%;
  }
  .btn-nuevo-evento {
    font-size: 14px;
    padding: 8px 12px;
  }
  .modal {
    max-width: 100%;
    padding: 15px;
  }
  .modal-buttons {
    flex-direction: column;
    gap: 8px;
  }
  .modal-buttons button {
    width: 100%;
  }
}
.event-form {
  display: flex;
  flex-direction: column;
}
.full-width {
  width: 100%;
  margin-bottom: 1rem;
}
.date-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.half-width {
  flex: 1 1 45%;
  min-width: 200px;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  margin-top: 1.5rem;
}
.row-fields {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.half-width {
  flex: 1 1 0;
  min-width: 200px;
}
.summary-container {
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.summary-header {
  width: 100%;
  text-align: right;
  margin-bottom: 8px;
}
.add-discount {
  color: var(--cf-brand-dark);
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
}
.add-discount:hover {
  text-decoration: underline;
}
.summary-table {
  min-width: 220px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px 16px;
  background-color: #fafafa;
}
.summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #333;
  padding: 4px 0;
}
.summary-row.total {
  font-weight: 600;
  font-size: 15px;
  color: #000;
}
.summary-row.total span:last-child {
  font-size: 16px;
}
hr {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 8px 0;
}
.lines-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.line-row {
  background: #fff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.line-row.cdk-drag-preview {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  transform: rotate(1deg);
}
.line-row.cdk-drag-placeholder {
  opacity: 0;
}
.drag-handle {
  cursor: grab;
  color: #9e9e9e;
}
.drag-handle:hover {
  color: var(--cf-brand-dark);
}
.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  border-radius: inherit;
}
.preinvoice-lines {
  -webkit-overflow-scrolling: touch;
  margin-bottom: 0.5rem;
}
.preinvoice-lines {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 1rem;
  background: #fafafa;
}
.lines-header {
  flex-shrink: 0;
}
.lines-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.lines-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 1150px;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}
@media (max-width: 768px) {
  .lines-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  .header-actions {
    flex-wrap: wrap;
    width: 100%;
    gap: 0.5rem;
  }
  .header-actions app-button {
    flex: 1 1 auto;
  }
  .summary-table {
    width: 100%;
  }
}
.line-card {
  background: #fff;
}
.line-flex {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.drag {
  flex: 0 0 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.end {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
}
.w-unit {
  flex: 0 0 140px;
  min-width: 0;
}
.w-qmeas {
  flex: 0 0 90px;
  min-width: 0;
}
.w-qty {
  flex: 0 0 90px;
  min-width: 0;
}
.w-price {
  flex: 0 0 110px;
  min-width: 0;
}
.w-disc {
  flex: 0 0 110px;
  min-width: 0;
}
.grow {
  flex: 1 1 0;
  min-width: 0;
}
.concept {
  flex-grow: 6;
  min-width: 220px;
}
.taxes {
  flex-grow: 3;
  min-width: 180px;
}
.line-flex app-field,
.line-flex app-input,
.line-flex app-autocomplete,
.line-flex app-multi-select-autocomplete {
  display: block;
  min-width: 0 !important;
  width: 100%;
}
.line-flex .mat-mdc-form-field,
.line-flex .form-control {
  min-width: 0 !important;
  width: 100%;
}
:host ::ng-deep app-autocomplete,
:host ::ng-deep app-multi-select-autocomplete {
  display: block;
}
.ef-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.ef-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.ef-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ef-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.ef-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.ef-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.ef-header__summary {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--cf-bg, #f4f6f8);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 8px;
  padding: 8px 16px;
}
.ef-header__summary-divider {
  width: 1px;
  height: 28px;
  background: var(--cf-border, #e5e7eb);
}
.ef-header__summary-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.ef-header__summary-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cf-text-muted, #6b7280);
}
.ef-header__summary-value {
  font-size: 0.925rem;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
  font-variant-numeric: tabular-nums;
}
.ef-header__summary-value--total {
  font-size: 1.05rem;
  color: var(--cf-brand-dark, #4d7a00);
}
.ef-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.ef-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.ef-body {
  padding: 14px 20px;
  flex: 1;
}
@media (max-width: 768px) {
  .ef-header {
    padding: 10px 14px;
    gap: 10px;
  }
  .ef-header__summary {
    display: none;
  }
  .ef-body {
    padding: 10px 12px;
  }
}
@media (max-width: 480px) {
  .ef-header {
    flex-wrap: wrap;
    gap: 8px;
  }
  .ef-header__actions {
    width: 100%;
    justify-content: flex-end;
  }
}
.ef-section__head--wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ef-section__head-extra {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ef-section__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: var(--cf-brand, #e3fd64);
  color: rgba(0, 0, 0, 0.85);
  font-size: 11px;
  font-weight: 700;
}
.ef-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}
@media (max-width: 600px) {
  .ef-two-col {
    grid-template-columns: 1fr;
  }
}
.ef-btn-add-line {
  height: 36px !important;
  padding: 0 14px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  color: #1a1d23 !important;
  background: #fff !important;
  border: 1px solid var(--cf-border, #e5e7eb) !important;
  box-shadow: none !important;
}
.ef-btn-add-line:hover {
  background: #f9fafb !important;
  border-color: #c5d94a !important;
}
.ef-btn-add-line--primary {
  background: var(--cf-brand, #e3fd64) !important;
  border-color: var(--cf-brand, #e3fd64) !important;
}
.ef-btn-add-line--primary:hover {
  background: #d4f03f !important;
  border-color: #d4f03f !important;
}
.ef-btn-add-line mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  margin-right: 4px;
}
.ef-head-check {
  font-size: 0.78rem;
}
.ef-empty-lines {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px;
  color: var(--cf-text-muted, #6b7280);
}
.ef-empty-lines mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  opacity: 0.4;
}
.ef-empty-lines p {
  margin: 0;
  font-size: 13px;
}
.ef-line-total {
  font-size: 13px;
  font-weight: 600;
  color: var(--cf-brand-dark, #4d7a00);
  white-space: nowrap;
  min-width: 70px;
  text-align: right;
}
.ef-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
}
.pf-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.ef-header__summary + .pf-header-actions {
  margin-left: 0;
}
.pf-btn-cancel {
  border-radius: 8px !important;
  white-space: nowrap;
}
.pf-side-by-side {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
  margin-bottom: 1rem;
}
.pf-side-by-side > .tf-card {
  height: 100%;
}
.pf-inline-error {
  margin: -8px 0 12px;
}
.pf-empty-lines--invalid {
  border: 1px dashed #fca5a5;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
}
@media (max-width: 992px) {
  .pf-side-by-side {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 992px) {
  .lines-scroll {
    overflow-x: hidden;
  }
  .lines-container {
    min-width: 0;
    padding: 0 !important;
  }
  .line-card {
    padding: 10px !important;
  }
  .line-flex {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 4px 10px;
    align-items: start;
  }
  .line-flex > * {
    min-width: 0 !important;
    width: auto;
  }
  .drag {
    display: none;
  }
  .concept,
  .taxes,
  .line-flex > .grow {
    grid-column: 1 / -1;
  }
  .end {
    grid-column: 1 / -1;
    justify-content: space-between;
    padding-top: 2px;
  }
  .line-flex ::ng-deep .mat-mdc-form-field,
  .line-flex ::ng-deep .mat-mdc-text-field-wrapper,
  .line-flex ::ng-deep .mat-mdc-form-field-flex,
  .line-flex ::ng-deep .mat-mdc-form-field-infix {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100%;
  }
  .pf-totals-bar {
    flex-wrap: wrap;
    gap: 8px;
  }
}
@media (max-width: 600px) {
  .line-flex {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ef-section__head-extra {
    width: 100%;
    margin-left: 0;
    justify-content: space-between;
  }
  .pf-header-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
.pf-header-totals {
  margin-left: auto;
}
.pf-header-totals + .pf-header-actions {
  margin-left: 0;
}
.pf-totals {
  justify-content: flex-end;
  padding: 12px 0 4px;
}
@media (max-width: 768px) {
  .pf-header-totals {
    display: none;
  }
  .pf-totals {
    justify-content: stretch;
  }
  .pf-totals .cf-total-card {
    flex: 1 1 calc(50% - 4px);
    justify-content: center;
  }
}
.pf-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 16px;
}
.pf-grid-2 > * {
  min-width: 0;
}
.pf-grid-2__full {
  grid-column: 1 / -1;
}
@media (max-width: 768px) {
  .pf-grid-2 {
    grid-template-columns: 1fr;
  }
}
.lines-scroll {
  max-height: 70vh;
  overflow-y: auto;
}
/*# sourceMappingURL=preinvoice-form.components.css.map */
